import React from 'react';
import { Icon } from 'antd-mobile';
import { href } from '../../../utils/util';
import './index.less';

class certificateList extends React.Component {
    constructor(...args) {
        super(...args);
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].style.cssText = 'background: #F4F4F5 !important';
    }

    render() {
        return (
            <div className="certificateListBox">
                <h2 style={{ paddingLeft: '0.14rem',color:'#999999',fontSize:'0.115rem' }}>绿色慧联</h2>
                <div className="blockBox">
                    <div className="block-mini">
                        <div className='listItem' onClick={() => { href(`/CertificateDetail?id=${1}`) }}>
                            <div className="left"><p>营业执照</p></div>
                            <div className='right'><Icon type='right' color="#DDDDDD"/></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default certificateList;


// WEBPACK FOOTER //
// ./src/staticPage/certificate/list/index.js